import { i18next } from '../i18n/index.js'

export function formatRelative(
  date: string | number | Date | null | undefined,
  locale: string,
): string {
  if (date == null) return ''
  const then = date instanceof Date ? date.getTime() : new Date(date).getTime()
  if (!Number.isFinite(then)) return String(date)

  const deltaMs = Math.max(0, Date.now() - then)
  const seconds = Math.floor(deltaMs / 1000)
  const t = i18next.getFixedT(locale.startsWith('en') ? 'en' : 'zh', 'common')

  if (seconds < 60) return t('relativeTime.justNow')

  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return t('relativeTime.minutesAgo', { count: minutes })

  const hours = Math.floor(minutes / 60)
  if (hours < 24) return t('relativeTime.hoursAgo', { count: hours })

  const days = Math.floor(hours / 24)
  if (days < 7) return t('relativeTime.daysAgo', { count: days })

  return new Intl.DateTimeFormat(locale.startsWith('en') ? 'en-US' : 'zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date(then))
}
